import { ForumSearchState } from "@/mk2/apps/forum/containers/ForumSearch/ForumSearch.reducers";

export const initialForumSearchState: ForumSearchState = {
    query: "",
};
